import { useEffect, useState } from 'react'

export interface TocEntry {
  id: string
  title: string
  level: 2 | 3
}

export function Toc({ entries }: { entries: TocEntry[] }) {
  const [active, setActive] = useState<string>('')

  useEffect(() => {
    if (entries.length === 0) return
    const observer = new IntersectionObserver(
      sections => {
        const visible = sections.filter(s => s.isIntersecting)
        if (visible.length > 0) setActive(visible[0].target.id)
      },
      { rootMargin: '-64px 0px -60% 0px' },
    )
    entries.forEach(e => {
      const el = document.getElementById(e.id)
      if (el) observer.observe(el)
    })
    return () => observer.disconnect()
  }, [entries])

  if (entries.length === 0) return null

  return (
    <aside className="w-[220px] shrink-0 fixed top-12 right-0 bottom-0 overflow-y-auto hidden xl:block">
      <div className="pt-8 px-4">
        <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-widest mb-3">On this page</p>
        <nav className="space-y-px">
          {entries.map(e => (
            <a
              key={e.id}
              href={`#${e.id}`}
              className={`block text-[12.5px] py-0.5 leading-snug transition-colors ${
                e.level === 3 ? 'pl-3' : ''
              } ${
                active === e.id
                  ? 'text-blue-600 font-medium'
                  : 'text-slate-500 hover:text-slate-900'
              }`}
            >
              {e.title}
            </a>
          ))}
        </nav>
      </div>
    </aside>
  )
}
